module.exports = __webpack_public_path__ + "img/login-bg.a19ead39.png";